export type {
  ContextAnnotation,
  ReferencedTweet,
  TweetAttachments,
  TweetAuthor,
  TweetAuthorAffiliation,
  TweetEntities,
} from '@sweetistics/contracts/tweets-canonical';
export {
  ContextAnnotationSchema,
  ReferencedTweetSchema,
  TweetAttachmentsSchema,
  TweetAuthorAffiliationSchema,
  TweetAuthorSchema,
  TweetEntitiesSchema,
} from '@sweetistics/contracts/tweets-canonical';
